module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value),
      expression: "value"
    }],
    class: [{
      'weui-badge_dot': _vm.value === 'dot'
    }, 'weui-badge'],
    style: (_vm.styleObj),
    on: {
      "click": _vm.onItemClick
    }
  }, [_vm._v(_vm._s(_vm.num))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-67389b3f!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/badges/badge.vue
// module id = 254
// module chunks = 0